import styled from 'styled-components'

export const Root = styled.div`
  /* background-color: red; */
`
